import { useEffect, useState, useRef, useContext } from "react";
import { toast } from "react-toastify";

import api from "../../../BrandOnBoarding/api";
import { DiscoveryContext } from "../discovery-context";
import { AuthContext } from "../../../context/auth-context";

export default function useHistory(type) {
  const [loading, setLoading] = useState(true);
  const [history, setHistory] = useState([]);
  const [error, setError] = useState("");
  const [hasReachedEnd, setHasReachedEnd] = useState(false);
  const [page, setPage] = useState(1);
  const abortCtrlRef = useRef();
  const discoveryCtx = useContext(DiscoveryContext);
  const { user } = useContext(AuthContext);
  const webSocketBaseURL = process.env.REACT_APP_ORCHESTRATOR_BASE_URL;

  useEffect(() => {
    if (abortCtrlRef.current) {
      abortCtrlRef.current.abort();
    }
    setHistory([]);
    setHasReachedEnd(false);
    setPage(1);
  }, [type]);

  async function getHistory(page = 1, limit = 5) {
    try {
      if (page == 1) {
        discoveryCtx.updateTransactionHistory({ clear: true })
      }
      setError("");
      // setLoading(true);
      if (abortCtrlRef.current) {
        abortCtrlRef.current.abort();
      }
      const abortCtrl = new AbortController();
      abortCtrlRef.current = abortCtrl;

      const response = await api.get(
        `${webSocketBaseURL}/getUserIdHistory/discovery/${type}/${user?.user_role?.user_id}`,
        {
          params: { page, limit },
          // signal: abortCtrl.signal
        }
      );
      // setLoading(false);
      if (response.status !== 200) {
        setError("Failed to fetch discovery")
        return;
      }
      const data = response.data;
      // if (data.length === 0 || data.length < limit) {
      //   setHasReachedEnd(true);
      // }
      discoveryCtx.updateTransactionHistory(data)
      return data
    } catch (error) {
      if (error.name === "CanceledError") {
        return;
      }
      setError("Failed to fetch discovery")
      // setLoading(false);
    }
  }

  async function deleteHistory(id) {
    try {
      const response = await api.delete(`${webSocketBaseURL}/${id}`);
      if (response.status === 200) {
        discoveryCtx.updateTransactionHistory({
          replace: true,
          data: discoveryCtx.state.transactionHistory.filter(history => history.transactionId !== id)
        });
      } else {
        toast.error("Failed to delete discovery");
      }
    } catch (error) {
      toast.error("Failed to delete discovery");
    }
  }

  return {
    loading,
    error,
    history,
    getHistory,
    setHistory,
    deleteHistory,
    hasReachedEnd,
    setHasReachedEnd,
    page,
    setPage,
    setLoading
  };
}
